import React, { useEffect, useState } from 'react';
import Layout from './common/Layout';
import Error from './common/Error';
import { useTranslation } from "react-i18next";
import Back from './common/Back';
import { useSelector } from "react-redux";
import { GetCountryName } from '../Country';
import { FadeLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import { isEmpty, join } from '../Util';

const BuyerIdentification = () => {

    const shouldSearchBuyer = useSelector((state) => state.Reducer.shouldSearchBuyer)
    const shouldIdentifyBuyer = useSelector((state) => state.Reducer.shouldIdentifyBuyer)
    const isTransactionProcessing = useSelector((state) => state.Reducer.isTransactionProcessing)
    const error = useSelector((state) => state.Reducer.error) 
    const purchaserBuyer = useSelector((state) => state.Reducer.purchaserBuyer)

    const [isLoading, setIsloading] = useState(true)
    
    useEffect(()=>{
        if (!shouldIdentifyBuyer)
            if (!shouldSearchBuyer )
                navigate("/Quotation")
            else 
                navigate("/BuyerSearch")
        else 
            setIsloading(false)
    },[])

    const handleQuotation = () => {   
        navigate("/Quotation", { state: { shouldPatchTransaction: true, buyer: purchaserBuyer} })
    }
    
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    return (
        <>
        { isLoading ? 
            <div className="transparent container">
                <div className="row ms-0 az-center">
                    <FadeLoader color="#FFFFFF"/>
                </div>
            </div> 
            : 
            <Layout isLarge={false}>

                { shouldIdentifyBuyer && isTransactionProcessing && isEmpty(error) &&
                    <>
                    <div className="az-pay-title">
                        {t("buyerIdentification.title")}
                    </div>

                    <div className="middle-font az-pay-subtitle">    
                        {t("buyerIdentification.incorrect.text")}  
                    </div>

                    <div className="mt-4 company-info">
                        <div className="row ms-0 pb-1">
                            <div className="col-md-6 col-sm-12 p-1">
                                <strong>{t("buyerIdentification.companyName.label")} </strong> 
                            </div>
                            <div className="col-md-6 col-sm-12 p-1">
                                {purchaserBuyer?.name}
                            </div>
                        </div>
                        <div className="row ms-0 mt-2 mt-2 pb-1">
                            <div className="col-md-6 col-sm-12 p-1">                    
                                <strong>{t("buyerIdentification.streetName.label")} </strong>
                            </div>
                            <div className="col-md-6 col-sm-12 p-1">
                                {purchaserBuyer?.address?.streetName}
                            </div>
                        </div>
                        <div className="row ms-0 mt-2 pb-1">
                            <div className="col-md-6 col-sm-12 p-1">
                                <strong>{t("buyerIdentification.streetNumber.label")} </strong> 
                            </div>
                            <div className="col-md-6 col-sm-12 p-1">
                                {purchaserBuyer?.address?.streetNumber}
                            </div>
                        </div>
                        <div className="row ms-0 mt-2 pb-1">
                            <div className="col-md-6 col-sm-12 p-1">
                                <strong>{t("buyerIdentification.city.label")} </strong>
                            </div>
                            <div className="col-md-6 col-sm-12 p-1">
                                {purchaserBuyer?.address?.city}
                            </div>
                        </div>
                        <div className="row ms-0 mt-2 pb-1">
                            <div className="col-md-6 col-sm-12 p-1">
                                <strong>{t("buyerIdentification.postalCode.label")} </strong> 
                            </div>
                            <div className="col-md-6 col-sm-12 p-1">
                            {purchaserBuyer?.address.postCode}
                            </div>
                        </div>
                        <div className="row ms-0 mt-2 pb-1">
                            <div className="col-md-6 col-sm-12 p-1">
                                <strong>{t("buyerIdentification.country.label")} </strong> 
                            </div>
                            <div className="col-md-6 col-sm-12 p-1">
                                {GetCountryName(purchaserBuyer?.address?.countryCode, i18n.language)}
                            </div>
                        </div>
                        <div className="row ms-0 mt-2 pb-1">
                            <div className="col-md-6 col-sm-12 p-1">
                                <strong>{t("buyerIdentification.id.label")} </strong> 
                            </div>
                            <div className="col-md-6 col-sm-12 p-1">
                                {join(purchaserBuyer?.mainIdentifierTypeCode, purchaserBuyer?.mainIdentifierValue)}
                            </div>
                        </div>
                    </div>

                    <div className="row me-0 mt-5">
                        <div className="col-12 d-flex justify-content-start">
                            <button className="az-btn" onClick={handleQuotation}>
                                {t("buyerIdentification.confirm.btn")}
                            </button>
                        </div>
                    </div>
                    </>
                }
                <Error renderer={!shouldIdentifyBuyer || !isTransactionProcessing} message={t('home.error.text')}/>
                <Back renderer={true} message={t('app.back.link')} />
            </Layout>
        }
        </>
    );
};  

export default BuyerIdentification;